import { requestFCMToken } from '../firebase';
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE } from '../config';
const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
  const [user,   setUser]   = useState(null);
  const [driver, setDriver] = useState(null);
  const [token,  setToken]  = useState(localStorage.getItem('d_token'));
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.get(`${API_BASE}/auth/me`)
        .then(r => { setUser(r.data.user); })
        .then(() => axios.get(`${API_BASE}/drivers/me/profile`))
        .then(r => {
          if (r.data.driver?.company_suspended) {
            logout();
            alert('تم إيقافك من قِبَل شركة التوصيل، تواصل مع الشركة');
          } else {
            setDriver(r.data.driver);
          }
        })
        .catch(() => logout())
        .finally(() => setLoading(false));
    } else { setLoading(false); }
  }, [token]);
  const login = async (phone, password) => {
    const r = await axios.post(`${API_BASE}/auth/login`, { phone, password });
    if (r.data.user.role !== 'driver') throw new Error('هذا الحساب مش حساب طيار');
    localStorage.setItem('d_token', r.data.token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${r.data.token}`;
    setToken(r.data.token);
    setUser(r.data.user);
    setDriver(r.data.driverProfile);
    // Request FCM token
    requestFCMToken().then(fcmToken => {
      if (fcmToken) {
        axios.post(`${API_BASE}/drivers/fcm-token`, { token: fcmToken }).catch(()=>{});
      }
    });
    return r.data;
  };
  const logout = () => {
    localStorage.removeItem('d_token');
    delete axios.defaults.headers.common['Authorization'];
    setToken(null); setUser(null); setDriver(null);
  };
  return (
    <AuthContext.Provider value={{ user, driver, token, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
export const useAuth = () => useContext(AuthContext);
